import chroma from 'chroma-js';
import {
  COLOR_SCALE_PRIMARY,
  COLOR_SCALE_SECONDARY,
  COLOR_SCALE_ACCENT_1,
  COLOR_SCALE_ACCENT_2,
  COLOR_SCALE_ACCENTS_COLORS,
  COLOR_SCALE_PRIMARY_COLORS,
  COLOR_SCALE_CHARTS_COLORS,
  COLOR_SCALE_CHARTS_DIGITAL_CHANNELS_COLORS,
  COLOR_SCALE_LOGO_COLORS,
} from './Constants';

/**
 * COLORS DARK MODE
 */
const LOGO_COLOR = 'rgb(42, 107, 183)'; /* #2A6BB7 Cerulean blue */

const BLACK_COLOR = 'rgb(0, 0, 0)';
const WHITE_COLOR = 'rgb(255, 255, 255)';

const PRIMARY_COLOR = 'rgb(116, 212, 37)'; /* #74D425 Yellow green */
const PRIMARY_COLOR_HIGHLIGHT = LOGO_COLOR;
const SECONDARY_COLOR = 'rgb(31, 186, 197)'; /* #1FBAC5 Pacific blue */
const THIRD_COLOR = 'rgb(255, 172, 41)'; /* #FFAC29 Bright yellow (Crayola) */
const FOURTH_COLOR = 'rgb(255, 105, 41)'; /* #FF6929 Smashed pumpkin */
const ERROR_COLOR = 'rgb(189, 0, 0)'; /* #BD0000 Boston university red */
const ERROR_COLOR_HIGHLIGHT = 'rgb(133, 0, 0)'; /* #850000 */

const BACKGROUND_COLOR_1 = 'rgb(9, 47, 64)'; /* #092F40 Rich black */
const BACKGROUND_COLOR_2 = 'rgb(12, 25, 41)'; /* #0C1929 Eerie black */
const BACKGROUND_COLOR_3 = 'rgb(09, 67, 93)'; /* #09435D Dark imperial blue */
const BACKGROUND_COLOR_4 = 'rgb(07, 07, 07)'; /* #070707 */
const BACKGROUND_COLOR_5 = 'rgb(06, 06, 06)'; /* #060606 */
const CONSTRAST_TEXT_1 = 'rgb(180, 180, 180)'; /* #b4b4b4 */
const CONSTRAST_TEXT_2 = 'rgb(240, 240, 240)'; /* #f0f0f0 */
const CONSTRAST_TEXT_3 = 'rgb(64, 64, 64)'; /* #404040 Black olive */
const CONSTRAST_TEXT_4 = 'rgb(145, 145, 145)'; /* #919192 Spanish gray */
const CONSTRANT_TEXT_5 = 'rgb(117, 117, 117)'; /* #757575 Sonic silver */

const ACCENT_COLOR_1 = 'rgb(238, 66, 102)'; /* #EE4266 Paradise pink */
const ACCENT_COLOR_2 = 'rgb(141, 106, 159)'; /* #8D6A97 Pomp and power */
/* ======================================================================= */

const BACKGROUND_COLOR = BACKGROUND_COLOR_4;
const TEXT_COLOR = CONSTRAST_TEXT_1;

const BUTTON_BACKGROUND_COLOR = CONSTRAST_TEXT_4;
const BUTTON_COLOR = CONSTRAST_TEXT_3;

const BUTTON_HOVER_BACKGROUND_COLOR = CONSTRANT_TEXT_5;
const BUTTON_HOVER_COLOR = BACKGROUND_COLOR_2;

const BUTTON_DISABLED_BACKGROUND_COLOR = CONSTRAST_TEXT_4;
const BUTTON_DISABLED_COLOR = 'rgb(64, 64, 64, 1)';

const BUTTON_PRIMARY_BACKGROUND_COLOR = BACKGROUND_COLOR_1;
const BUTTON_PRIMARY_COLOR = CONSTRAST_TEXT_2;

const BUTTON_PRIMARY_HOVER_BACKGROUND_COLOR = BACKGROUND_COLOR_1;
const BUTTON_PRIMARY_HOVER_COLOR = WHITE_COLOR;

const BUTTON_PRIMARY_DISABLED_BACKGROUND_COLOR = BACKGROUND_COLOR_1;
const BUTTON_PRIMARY_DISABLED_COLOR = 'rgb(200, 200, 200, 1)';

const BUTTON_NEGATIVE_HOVER_BACKGROUND_COLOR = ERROR_COLOR_HIGHLIGHT;
const BUTTON_NEGATIVE_HOVER_COLOR = WHITE_COLOR;

const BUTTON_NEGATIVE_BACKGROUND_COLOR = ERROR_COLOR;
const BUTTON_NEGATIVE_COLOR = CONSTRAST_TEXT_2;

const BUTTON_MULTISTATE_ACTIVE_COLOR = PRIMARY_COLOR;

const ICON_PRIMARY_HOVER_COLOR = LOGO_COLOR;
const ICON_PRIMARY_COLOR = BACKGROUND_COLOR_3;

const HEADER_BACKGROUND_COLOR = BACKGROUND_COLOR_2;
const HEADER_COLOR = CONSTRAST_TEXT_2;

const FEEDBACK_COLOR = THIRD_COLOR;
const ALARM_COLOR = ERROR_COLOR;
const WARNING_COLOR = THIRD_COLOR;
const POSITIVE_COLOR = PRIMARY_COLOR;
const INFORMATION_COLOR = CONSTRAST_TEXT_1;
const DISABLE_COLOR = 'rgb(125, 125, 125, 1)'; /* #7D7D7D lavender gray */ 

const BOX_HEADER_BACKGROUND_COLOR = BACKGROUND_COLOR_3;
const BOX_HEADER_COLOR = CONSTRAST_TEXT_1;
const BOX_HEADER_BACKGROUND_DISABLED_COLOR = BACKGROUND_COLOR_2;
const BOX_HEADER_TOP_BAR_DISABLED_COLOR = CONSTRAST_TEXT_1;
const BOX_BACKGROUND_COLOR = BACKGROUND_COLOR_2;
const BOX_COLOR = CONSTRAST_TEXT_1;
const BOX_BORDER_COLOR = BACKGROUND_COLOR_3;

const ICON_COLOR = CONSTRAST_TEXT_1;
const ICON_COLOR_HIGHLIGHT = CONSTRAST_TEXT_2;
const ICON_BACKGROUND_COLOR = BACKGROUND_COLOR_3;

const ACTION_BUTTON_BACKGROUND_ACTIVE_COLOR = BACKGROUND_COLOR_1;
const ACTION_BUTTON_BACKGROUND_INACTIVE_COLOR = BACKGROUND_COLOR_1;
const ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR = CONSTRAST_TEXT_2;
const ACTION_BUTTON_CONSTRAST_TEXT_DISABLE_COLOR = 'rgb(136, 134, 134, 0.7)';
const ACTION_BUTTON_SHADOW_HOVER = '1px 1px 2px rgba(9, 47, 64, 1)';

const ACTION_BUTTON_ICON_LIGHT_ACTIVE_COLOR = THIRD_COLOR;
const ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR = PRIMARY_COLOR;
const ACTION_BUTTON_ICON_SAVE_ENERGY_ACTIVE_COLOR = PRIMARY_COLOR;
const ACTION_BUTTON_ICON_DEFROST_ACTIVE_COLOR = SECONDARY_COLOR;
const ACTION_BUTTON_ICON_SETPOINT_ACTIVE_COLOR = PRIMARY_COLOR;

const ACTION_BUTTON_ICON_TURN_KNIFE_WIPER_ACTIVE_COLOR = PRIMARY_COLOR;
const ACTION_BUTTON_ICON_TURN_SUPERFROST_ACTIVE_COLOR = SECONDARY_COLOR;
const ACTION_BUTTON_ICON_TURN_HUMIDITY_ACTIVE_COLOR = SECONDARY_COLOR;
const ACTION_BUTTON_ICON_TURN_GLASS_HEATER_ACTIVE_COLOR = FOURTH_COLOR;
const ACTION_BUTTON_ICON_TURN_DOOR_HEATER_ACTIVE_COLOR = FOURTH_COLOR;

const MAIN_MENU_ITEM_ACTIVE = CONSTRAST_TEXT_2;
const MAIN_MENU_ITEM_INACTIVE = CONSTRAST_TEXT_1;
const MAIN_MENU_ITEM_DISABLE = DISABLE_COLOR;
const MAIN_MENU_BACKGROUND_HOVER = BACKGROUND_COLOR_1;
const MAIN_MENU_DROPDOWN_MENU_ITEM_BACKGROUND_COLOR = BACKGROUND_COLOR_1;
const MAIN_MENU_DROPDOWN_MENU_ITEM_COLOR = CONSTRAST_TEXT_2;

const POPUP_MAIN_MENU_HEADER_BACKGROUND = BACKGROUND_COLOR_1;
const POPUP_MAIN_MENU_HEADER_COLOR = CONSTRAST_TEXT_1;
const POPUP_MAIN_MENU_HEADER_COLOR_HIGHLIGHT = PRIMARY_COLOR;
const POPUP_MAIN_MENU_BACKGROUND = BACKGROUND_COLOR_2;
const POPUP_MAIN_MENU_COLOR = BOX_COLOR;
const POPUP_SHADOW = '1px 1px 2px rgba(9, 47, 64, 0.5)';

const PANEL_BACKGROUND_COLOR = BACKGROUND_COLOR_2;
const PANEL_COLOR = CONSTRAST_TEXT_1;
const PANEL_HEADER_BACKGROUND_COLOR = BACKGROUND_COLOR_3;
const PANEL_HEADER_BAR_COLOR = LOGO_COLOR;
const PANEL_HEADER_COLOR = CONSTRAST_TEXT_1;
const PANEL_ICON_HEADER_COLOR = CONSTRAST_TEXT_1;
const PANEL_ICON_HEADER_HIGHLIGHT_COLOR = CONSTRAST_TEXT_2;

const PANEL_SECONDARY_BORDER_COLOR = BACKGROUND_COLOR_3;

const INPUT_COLOR = CONSTRAST_TEXT_1;
const INPUT_BACKGROUND_COLOR = BACKGROUND_COLOR_3;
const INPUT_LABEL_COLOR = CONSTRAST_TEXT_1;
const INPUT_BORDER_COLOR = CONSTRAST_TEXT_3;
const INPUT_FOCUS_BORDER_COLOR = CONSTRANT_TEXT_5;
const INPUT_DISABLED = CONSTRAST_TEXT_2;

const SLIDER_BAR = CONSTRAST_TEXT_1;
const SLIDER_BAR_FILL = LOGO_COLOR;
const PROGRESS_BAR_FILL_COLOR = BACKGROUND_COLOR_3;
const PROGRESS_BAR_BACKGROUND_COLOR = CONSTRAST_TEXT_3;

const STEPS_GROUP_BORDER_COLOR = BACKGROUND_COLOR_1;
const STEPS_STEP_COLOR = TEXT_COLOR;
const STEPS_STEP_BACKGROUND_COLOR = BACKGROUND_COLOR_2;
const STEPS_STEP_ACTIVE_BACKGROUND_COLOR = BACKGROUND_COLOR_3;
const STEPS_STEP_COMPLETED_ICON_COLOR = PRIMARY_COLOR;

const TABLE_HEADER_BACKGROUND_COLOR = BACKGROUND_COLOR_3;
const TABLE_HEADER_COLOR = TEXT_COLOR;
const TABLE_ROW_BACKGROUND_COLOR = BACKGROUND_COLOR_2;
const TABLE_ROW_COLOR = TEXT_COLOR;
const TABLE_ROW_ACTIVE_COLOR = PRIMARY_COLOR;
const TABLE_ROW_ACTIVE_BACKGROUND_COLOR = BACKGROUND_COLOR_2;
const TABLE_ROW_POSITIVE_BACKGROUND_COLOR = BACKGROUND_COLOR_4;

const MENU_BACKGROUND_COLOR = BACKGROUND_COLOR_1;
const MENU_ITEM_COLOR = TEXT_COLOR;
const MENU_ITEM_ACTIVE_COLOR = PRIMARY_COLOR;
const MENU_SEPARATOR_COLOR = BACKGROUND_COLOR_2;

const MODAL_BACKGROUND_COLOR = BACKGROUND_COLOR_2;
const MODAL_COLOR = TEXT_COLOR;

const BOX_SENSOR_BACKGROUND_COLOR_1 = PRIMARY_COLOR;
const BOX_SENSOR_BACKGROUND_COLOR_2 = SECONDARY_COLOR;
const BOX_SENSOR_BACKGROUND_COLOR_3 = THIRD_COLOR;
const BOX_SENSOR_BACKGROUND_COLOR_4 = ACCENT_COLOR_2;
const BOX_SENSOR_BACKGROUND_COLOR_ERROR = ERROR_COLOR;
const BOX_SENSOR_BACKGROUND_COLOR_OK = PRIMARY_COLOR;
const BOX_SENSOR_BACKGROUND_COLOR_INFORMATION = CONSTRAST_TEXT_1;
const BOX_SENSOR_COLOR = WHITE_COLOR;
const BOX_MAIN_SENSOR_COLOR = PRIMARY_COLOR;
const BOX_MAIN_SENSOR_COLOR_POSITIVE = POSITIVE_COLOR;

const SINGLE_DATA_TITLE_BACKGROUND_COLOR = BACKGROUND_COLOR_3;
const SINGLE_DATA_TITLE_COLOR = CONSTRAST_TEXT_4;
const SINGLE_DATA_VALUE_COLOR = WHITE_COLOR;

const CONTROL_UNIT_DETAILS_BACKGROUND_COLOR = BACKGROUND_COLOR_4;
const CONTROL_UNIT_DETAILS_CHART_BACKGROUND_COLOR_ACCENT = BACKGROUND_COLOR_5;

const DATETIME_PICKER_BORDER_COLOR = BACKGROUND_COLOR_1;
const DATETIME_PICKER_SELECTED_DAY_BACKGROUND_COLOR = BACKGROUND_COLOR_1;
const DATETIME_PICKER_TODAY_CORNER_ARROW_BACKGROUND_COLOR = WHITE_COLOR;

const PAGINATION_BACKGROUND_COLOR = ACTION_BUTTON_BACKGROUND_ACTIVE_COLOR;

const MESSAGE_BACKGROUND_COLOR = BACKGROUND_COLOR_3;
const MESSAGE_BORDER_COLOR = BACKGROUND_COLOR_3;
const MESSAGE_COLOR = TEXT_COLOR;

const SIDER_BAR_MENU_BACKGROUND_COLOR = BACKGROUND_COLOR_2;
const SIDER_BAR_MENU_COLOR = CONSTRAST_TEXT_1;
const SIDER_BAR_MENU_ITEM_ACTIVE_COLOR = CONSTRAST_TEXT_2;
const SIDER_BAR_MENU_ITEM_BAR_ACTIVE_COLOR = LOGO_COLOR;
const SIDE_BAR_MENU_ICON_CORNER_COLOR = LOGO_COLOR;

const SIDER_BAR_MENU_HOVER_BACKGROUND_COLOR = BACKGROUND_COLOR_1;
const SIDER_BAR_MENU_HOVER_COLOR = CONSTRAST_TEXT_2;

const ACCORDION_TITLE_BORDER_COLOR = BACKGROUND_COLOR_2;
const ACCORDION_TITLE_BACKGROUND_COLOR = BACKGROUND_COLOR_1;
const ACCORDION_TITLE_COLOR = CONSTRAST_TEXT_1;
const ACCORDION_SELECTED_TITLE_BACKGROUND_COLOR = BACKGROUND_COLOR_3;
const ACCORDION_SELECTED_TITLE_COLOR = PRIMARY_COLOR;

const PARAMETER_BOX_BACKGROUND_COLOR = 'inherit';
const PARAMETER_BOX_BORDER_COLOR = BACKGROUND_COLOR_1;

const CHART_AXES_COLOR = CONSTRAST_TEXT_3;
const CHART_NOTE_COLOR = CONSTRAST_TEXT_1;

const BACKGROUND_COLOR_SNACKBAR_POSITIVE = PRIMARY_COLOR;
const COLOR_SNACKBAR_POSITIVE = WHITE_COLOR;
const BACKGROUND_COLOR_SNACKBAR_NEGATIVE = ERROR_COLOR_HIGHLIGHT;
const COLOR_SNACKBAR_NEGATIVE = WHITE_COLOR;
const BACKGROUND_COLOR_SNACKBAR_FEEDBACK = THIRD_COLOR;
const COLOR_SNACKBAR_FEEDBACK = WHITE_COLOR;

const BAR_VERTICAL_FILLED = LOGO_COLOR;
const BAR_VERTICAL_NOT_FILLED = CONSTRAST_TEXT_3;

const darkMode = () => ({
  LOGO_COLOR,
  BLACK_COLOR,
  WHITE_COLOR,
  PRIMARY_COLOR,
  PRIMARY_COLOR_HIGHLIGHT,
  SECONDARY_COLOR,
  THIRD_COLOR,
  FOURTH_COLOR,
  ERROR_COLOR,
  BACKGROUND_COLOR_1,
  BACKGROUND_COLOR_2,
  BACKGROUND_COLOR_3,
  BACKGROUND_COLOR_4,
  CONSTRAST_TEXT_1,
  CONSTRAST_TEXT_2,
  ACCENT_COLOR_1,
  ACCENT_COLOR_2,
  BACKGROUND_COLOR,
  TEXT_COLOR,
  BUTTON_BACKGROUND_COLOR,
  BUTTON_COLOR,
  BUTTON_HOVER_BACKGROUND_COLOR,
  BUTTON_HOVER_COLOR,
  BUTTON_DISABLED_BACKGROUND_COLOR,
  BUTTON_DISABLED_COLOR,
  BUTTON_PRIMARY_BACKGROUND_COLOR,
  BUTTON_PRIMARY_COLOR,
  BUTTON_PRIMARY_HOVER_BACKGROUND_COLOR,
  BUTTON_PRIMARY_HOVER_COLOR,
  BUTTON_PRIMARY_DISABLED_BACKGROUND_COLOR,
  BUTTON_PRIMARY_DISABLED_COLOR,

  BUTTON_NEGATIVE_HOVER_BACKGROUND_COLOR,
  BUTTON_NEGATIVE_HOVER_COLOR,
  BUTTON_NEGATIVE_BACKGROUND_COLOR,
  BUTTON_NEGATIVE_COLOR,

  BUTTON_MULTISTATE_ACTIVE_COLOR,

  ICON_PRIMARY_HOVER_COLOR,
  ICON_PRIMARY_COLOR,

  HEADER_BACKGROUND_COLOR,
  HEADER_COLOR,
  FEEDBACK_COLOR,
  ALARM_COLOR,
  WARNING_COLOR,
  POSITIVE_COLOR,
  INFORMATION_COLOR,
  DISABLE_COLOR,
  BOX_HEADER_BACKGROUND_COLOR,
  BOX_HEADER_COLOR,
  BOX_HEADER_BACKGROUND_DISABLED_COLOR,
  BOX_HEADER_TOP_BAR_DISABLED_COLOR,
  BOX_BACKGROUND_COLOR,
  BOX_BORDER_COLOR,
  BOX_COLOR,
  ICON_COLOR,
  ICON_COLOR_HIGHLIGHT,
  ICON_BACKGROUND_COLOR,
  ACTION_BUTTON_BACKGROUND_ACTIVE_COLOR,
  ACTION_BUTTON_BACKGROUND_INACTIVE_COLOR,
  ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR,
  ACTION_BUTTON_CONSTRAST_TEXT_DISABLE_COLOR,
  ACTION_BUTTON_SHADOW_HOVER,
  ACTION_BUTTON_ICON_LIGHT_ACTIVE_COLOR,
  ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR,
  ACTION_BUTTON_ICON_SAVE_ENERGY_ACTIVE_COLOR,
  ACTION_BUTTON_ICON_DEFROST_ACTIVE_COLOR,
  ACTION_BUTTON_ICON_SETPOINT_ACTIVE_COLOR,

  ACTION_BUTTON_ICON_TURN_KNIFE_WIPER_ACTIVE_COLOR,
  ACTION_BUTTON_ICON_TURN_SUPERFROST_ACTIVE_COLOR,
  ACTION_BUTTON_ICON_TURN_HUMIDITY_ACTIVE_COLOR,
  ACTION_BUTTON_ICON_TURN_GLASS_HEATER_ACTIVE_COLOR,
  ACTION_BUTTON_ICON_TURN_DOOR_HEATER_ACTIVE_COLOR,

  MAIN_MENU_ITEM_ACTIVE,
  MAIN_MENU_ITEM_INACTIVE,
  MAIN_MENU_ITEM_DISABLE,
  MAIN_MENU_BACKGROUND_HOVER,
  MAIN_MENU_DROPDOWN_MENU_ITEM_BACKGROUND_COLOR,
  MAIN_MENU_DROPDOWN_MENU_ITEM_COLOR,

  POPUP_MAIN_MENU_HEADER_BACKGROUND,
  POPUP_MAIN_MENU_HEADER_COLOR,
  POPUP_MAIN_MENU_HEADER_COLOR_HIGHLIGHT,
  POPUP_MAIN_MENU_BACKGROUND,
  POPUP_MAIN_MENU_COLOR,
  POPUP_SHADOW,
  PANEL_BACKGROUND_COLOR,
  PANEL_COLOR,
  PANEL_HEADER_BACKGROUND_COLOR,
  PANEL_HEADER_BAR_COLOR,
  PANEL_HEADER_COLOR,
  PANEL_ICON_HEADER_COLOR,
  PANEL_ICON_HEADER_HIGHLIGHT_COLOR,

  PANEL_SECONDARY_BORDER_COLOR,

  INPUT_COLOR,
  INPUT_BACKGROUND_COLOR,
  INPUT_LABEL_COLOR,
  INPUT_BORDER_COLOR,
  INPUT_FOCUS_BORDER_COLOR,
  INPUT_DISABLED,
  SLIDER_BAR,
  SLIDER_BAR_FILL,
  PROGRESS_BAR_FILL_COLOR,
  PROGRESS_BAR_BACKGROUND_COLOR,

  STEPS_GROUP_BORDER_COLOR,
  STEPS_STEP_COLOR,
  STEPS_STEP_BACKGROUND_COLOR,
  STEPS_STEP_ACTIVE_BACKGROUND_COLOR,
  STEPS_STEP_COMPLETED_ICON_COLOR,

  TABLE_HEADER_BACKGROUND_COLOR,
  TABLE_HEADER_COLOR,
  TABLE_ROW_BACKGROUND_COLOR,
  TABLE_ROW_COLOR,
  TABLE_ROW_ACTIVE_COLOR,
  TABLE_ROW_ACTIVE_BACKGROUND_COLOR,
  TABLE_ROW_POSITIVE_BACKGROUND_COLOR,

  MENU_BACKGROUND_COLOR,
  MENU_ITEM_COLOR,
  MENU_ITEM_ACTIVE_COLOR,
  MENU_SEPARATOR_COLOR,

  MODAL_BACKGROUND_COLOR,
  MODAL_COLOR,

  BOX_SENSOR_BACKGROUND_COLOR_1,
  BOX_SENSOR_BACKGROUND_COLOR_2,
  BOX_SENSOR_BACKGROUND_COLOR_3,
  BOX_SENSOR_BACKGROUND_COLOR_4,
  BOX_SENSOR_BACKGROUND_COLOR_ERROR,
  BOX_SENSOR_BACKGROUND_COLOR_OK,
  BOX_SENSOR_BACKGROUND_COLOR_INFORMATION,
  BOX_SENSOR_COLOR,
  BOX_MAIN_SENSOR_COLOR,
  BOX_MAIN_SENSOR_COLOR_POSITIVE,

  SINGLE_DATA_TITLE_BACKGROUND_COLOR,
  SINGLE_DATA_TITLE_COLOR,
  SINGLE_DATA_VALUE_COLOR,

  CONTROL_UNIT_DETAILS_BACKGROUND_COLOR,
  CONTROL_UNIT_DETAILS_CHART_BACKGROUND_COLOR_ACCENT,

  DATETIME_PICKER_BORDER_COLOR,
  DATETIME_PICKER_SELECTED_DAY_BACKGROUND_COLOR,
  DATETIME_PICKER_TODAY_CORNER_ARROW_BACKGROUND_COLOR,

  PAGINATION_BACKGROUND_COLOR,

  MESSAGE_BACKGROUND_COLOR,
  MESSAGE_BORDER_COLOR,
  MESSAGE_COLOR,

  SIDER_BAR_MENU_BACKGROUND_COLOR,
  SIDER_BAR_MENU_COLOR,
  SIDER_BAR_MENU_ITEM_ACTIVE_COLOR,
  SIDER_BAR_MENU_ITEM_BAR_ACTIVE_COLOR,
  SIDE_BAR_MENU_ICON_CORNER_COLOR,
  SIDER_BAR_MENU_HOVER_BACKGROUND_COLOR,
  SIDER_BAR_MENU_HOVER_COLOR,

  ACCORDION_TITLE_BORDER_COLOR,
  ACCORDION_TITLE_BACKGROUND_COLOR,
  ACCORDION_TITLE_COLOR,
  ACCORDION_SELECTED_TITLE_BACKGROUND_COLOR,
  ACCORDION_SELECTED_TITLE_COLOR,
  PARAMETER_BOX_BACKGROUND_COLOR,
  PARAMETER_BOX_BORDER_COLOR,

  CHART_AXES_COLOR,
  CHART_NOTE_COLOR,

  BACKGROUND_COLOR_SNACKBAR_POSITIVE,
  COLOR_SNACKBAR_POSITIVE,
  BACKGROUND_COLOR_SNACKBAR_NEGATIVE,
  COLOR_SNACKBAR_NEGATIVE,
  BACKGROUND_COLOR_SNACKBAR_FEEDBACK,
  COLOR_SNACKBAR_FEEDBACK,

  BAR_VERTICAL_FILLED,
  BAR_VERTICAL_NOT_FILLED,
});

/* scale colors - Gradient
 * @param int totalColors: number of colors to return
 * @param option [
 *  COLOR_SCALE_PRIMARY_COLORS: gradient using the primary colors,
 *  COLOR_SCALE_ACCENTS_COLORS: gradient using the accent colors,
 *  COLOR_SCALE_LOGO_COLORS: gradient using the logo colors,
 *  COLOR_SCALE_PRIMARY: gradient using white and the primary color,
 *  COLOR_SCALE_SECONDARY: gradient using white and secondary color ,
 *  COLOR_SCALE_ACCENT_1: gradient using white and accent color 1,
 *  COLOR_SCALE_ACCENT_2: gradient using white and accent color 2,
 * ]
 * @return array colors
 */
export const colorScaleDark = (totalColors, option) => {
  switch (option) {
    case COLOR_SCALE_PRIMARY_COLORS:
      return chroma
        .scale([LOGO_COLOR, FOURTH_COLOR, PRIMARY_COLOR])
        .mode('lch')
        .colors(totalColors);
    case COLOR_SCALE_CHARTS_COLORS:
      return chroma
        .scale([
          ACCENT_COLOR_2,
          ACCENT_COLOR_1,
          FOURTH_COLOR,
          THIRD_COLOR,
          SECONDARY_COLOR,
          PRIMARY_COLOR,
        ])
        .mode('lch')
        .colors(totalColors);
    case COLOR_SCALE_CHARTS_DIGITAL_CHANNELS_COLORS:
      return chroma
        .scale([
          PRIMARY_COLOR,
          SECONDARY_COLOR,
          PRIMARY_COLOR_HIGHLIGHT,
          THIRD_COLOR,
          ACCENT_COLOR_1,
          ACCENT_COLOR_2,
          FOURTH_COLOR,
        ])
        .mode('lch')
        .colors(totalColors);
    case COLOR_SCALE_ACCENTS_COLORS:
      return chroma
        .scale([PRIMARY_COLOR, SECONDARY_COLOR, ACCENT_COLOR_2, ACCENT_COLOR_1])
        .mode('lch')
        .colors(totalColors);
    case COLOR_SCALE_LOGO_COLORS:
      return chroma
        .scale([LOGO_COLOR, BACKGROUND_COLOR_1, BACKGROUND_COLOR_3])
        .mode('lch')
        .colors(totalColors);
    case COLOR_SCALE_PRIMARY:
      return chroma
        .scale([WHITE_COLOR, PRIMARY_COLOR])
        .mode('lch')
        .colors(totalColors);
    case COLOR_SCALE_SECONDARY:
      return chroma
        .scale([WHITE_COLOR, SECONDARY_COLOR])
        .mode('lch')
        .colors(totalColors);
    case COLOR_SCALE_ACCENT_1:
      return chroma
        .scale([WHITE_COLOR, ACCENT_COLOR_1])
        .mode('lch')
        .colors(totalColors);
    case COLOR_SCALE_ACCENT_2:
      return chroma
        .scale([WHITE_COLOR, ACCENT_COLOR_2])
        .mode('lch')
        .colors(totalColors);
    default:
      return chroma
        .scale([PRIMARY_COLOR, SECONDARY_COLOR])
        .mode('lch')
        .colors(totalColors);
  }
};

export default darkMode;
